import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../static/styles/SelectGame.module.css';
import closeIcon from '../static/img/SelectGame/iconCloseButton.svg';
import { fetchAvailableGames, fetchGameChallenges } from '../api/games';

import pubgImage from '../static/img/DailyGamingTasks/imagePubgGaming.avif';
import apexImage from '../static/img/DailyGamingTasks/imageApexLegendsGaming.avif';
import codImage from '../static/img/DailyGamingTasks/imageCODGaming.avif';
import minecraftImage from '../static/img/DailyGamingTasks/imageMinecraftGaming.avif';
import clashOfClansImage from '../static/img/DailyGamingTasks/imageCOCGaming.avif';
import clashRoyaleImage from '../static/img/DailyGamingTasks/imageCRGaming.avif';
import fortniteImage from '../static/img/DailyGamingTasks/imageFortniteGaming.avif';
import amongUsImage from '../static/img/DailyGamingTasks/imageAmongUsGaming.avif';
import subwaySurfersImage from '../static/img/DailyGamingTasks/imageSubSurfGaming.avif';
import valorantImage from '../static/img/DailyGamingTasks/imageValorantGaming.avif';
import freeFireImage from '../static/img/DailyGamingTasks/imageFreeFireGaming.avif';
import robloxImage from '../static/img/DailyGamingTasks/imageRobloxGaming.avif';
import fifaImage from '../static/img/DailyGamingTasks/imageFifaGaming.avif';
import eightBallImage from '../static/img/DailyGamingTasks/image8BallPool.avif';

import { getActiveDayData } from '../api/auth';
import MessagePopup from '../components/MessagePopup';
import { trackGameSelection } from '../utils/analytics';

const getGameImage = (gameName) => {
  switch (gameName.toLowerCase()) {
    case 'pubg mobile': return pubgImage;
    case 'apex legends': return apexImage;
    case 'call of duty': return codImage;
    case 'minecraft': return minecraftImage;
    case 'clash of clans': return clashOfClansImage;
    case 'clash royale': return clashRoyaleImage;
    case 'fortnite': return fortniteImage;
    case 'among us': return amongUsImage;
    case 'subway surfers': return subwaySurfersImage;
    case 'valorant': return valorantImage;
    case 'freefire': return freeFireImage;
    case 'roblox': return robloxImage;
    case 'fifa mobile': return fifaImage;
    case '8 ball pool': return eightBallImage;
    default: return null;
  }
};

const SelectGame = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showMessagePopup, setShowMessagePopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState();

  useEffect(() => {
    const loadGames = async () => {
      try {
        setLoading(true);
        const response = await fetchAvailableGames();
        if (response.success && response.data) {
          setGames(response.data);
        } else {
          setError('Failed to load games');
        }
      } catch (err) {
        setError('Error loading games');
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      loadGames();
    }
  }, [isOpen]);

  const handleGameSelect = async (gameId, gameName) => {
    // sessionStorage.setItem('gameId', gameId);
    // console.log(`Selected game: ${gameName} with ID: ${gameId}`);
    try {
      const respose = await fetchGameChallenges(gameId);
      if (respose.success) {
        sessionStorage.setItem('gameId', JSON.stringify(gameId));
        trackGameSelection(gameName, gameId);
        sessionStorage.setItem('rewardClaimed', 'true');
        const activeDayData = await getActiveDayData();
        if (activeDayData) {
          sessionStorage.setItem("activeDayData", JSON.stringify(activeDayData));
          sessionStorage.setItem('activeDay', activeDayData.active_streak);
          sessionStorage.setItem('gameId', activeDayData.gameId);
          onClose();
          navigate('/tasks');
        }
      } else {
        setShowMessagePopup(true);
        setPopupMessage(respose.message)
        // return;
      }
      // onClose();
    } catch (error) {
    }
  };

  const handleClose = () => {
    onClose();
  };

  const gradients = [
    "linear-gradient(135deg, #FF7A00, #A84500)",
    "linear-gradient(135deg, #7A0000, #2A0000)",
    "linear-gradient(135deg, #0A1A3D, #000A1A)",
    "linear-gradient(135deg, #0A3A4A, #001A28)",
    "linear-gradient(135deg, #0A283D, #000A1A)",
    "linear-gradient(135deg, #0D3A14, #001408)",
  ];

  if (!isOpen) return null;

  return (
    <div className={styles['game-selection-container']}>
      <div className={styles['game-selection-overlay']}>
        <div className={styles['close-button']} onClick={handleClose}>
          <img src={closeIcon} alt="Close" />
        </div>

        <div className={styles['select-game-header']}>
          <spam className={styles['select-game-button']}>SELECT YOUR GAME</spam>
          <h5 style={{ textAlign: 'center' }}>Select the game to complete your daily task and earn extra credits</h5>
        </div>


        {loading ? (
          <div className={styles.loading}>Loading games...</div>
        ) : error ? (
          <div className={styles.error}>{error}</div>
        ) : (
          <div className={styles['games-grid']}>
            {games.map((game, index) => {
              const gameImage = getGameImage(game.name) || game.thumbnail;
              return (
                <div
                  key={game.gameId}
                  className={styles['game-card']}
                  onClick={() => handleGameSelect(game.gameId, game.name)}
                >
                  <div
                    key={game.gameId || index}
                    className={styles["game-image-container"]}
                    style={{
                      "--bg": gradients[index % gradients.length],
                    }}
                  >
                    <img
                      src={gameImage}
                      alt={game.name}
                      className={styles["game-image"]}
                    />

                    <div className={styles["game-name"]}>
                      {game.name.length > 10
                        ? `${game.name.substring(0, 10)}...`
                        : game.name}
                    </div>

                    <button className={styles["game-button"]}>
                      Tap to play
                    </button>
                  </div>

                </div>
              );
            })}
          </div>
        )}
      </div>
      {showMessagePopup && (
        <MessagePopup
          isOpen={showMessagePopup}
          onClose={onClose}
          message={popupMessage}
        />
      )}
    </div>
  );
};

export default SelectGame;